import React from "react";
import { useTranslation } from "react-i18next";
import { useBoundStore } from "@/stores";
import { Button } from "@/shared/ui/button";

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation('common');
  const isAuthenticated = useBoundStore.use.isAuthenticated();

  const handleNavigation = () => {
    if (isAuthenticated) {
      window.location.href = "/my-account";
    } else {
      window.location.href = "/";
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 w-full">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-600 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">{t('errors.pageNotFound')}</h2>
        <p className="text-gray-600 mb-8">{t('errors.pageNotFoundDesc')}</p>
        <Button
          onClick={handleNavigation}
          className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
        >
          {isAuthenticated ? t('errors.goToAccount') : t('errors.goToLogin')}
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;